<template>
    <div class="nav_box" :class="{navActive:navActive}">
        <div class="nav">
            <div class="nav_left pointer" @click="$router.push({name:'home'})">
                <img class="nav_logo" :src="logo" alt="">
            </div>
            <div class="nav_right">
                <el-menu
                        :default-active="activeIndex"
                        class="el-menu-demo"
                        mode="horizontal"
                        @select="handleSelect"
                        router
                        background-color="#fff"
                        text-color="#4A4A4A"
                        active-text-color="#FFB01E">
                    <el-menu-item index="/home">首页</el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">资产竞拍
                            <img class="arrow" src="../assets/images/arrow_down.png" alt="">
                        </template>
                        <!--<el-menu-item index="2-1" @click="$router.push({name:'auction'})">国产拍卖</el-menu-item>-->
                        <!--<el-menu-item index="2-2" @click="$router.push({name:'auctionSec'})">二手房</el-menu-item>-->
                        <el-menu-item :index="'/auction/0/' + item.id.toString()" v-for="item in auction"
                                      :key="item.id">
                            <div class="">{{ item.name }}</div>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="3">
                        <template slot="title">资产竞租
                            <img class="arrow" src="../assets/images/arrow_down.png" alt="">
                        </template>
                        <el-menu-item :index="'/auction/1/' + item.id.toString()" v-for="item in takeRent"
                                      :key="item.id">
                            <div class="">{{ item.name }}</div>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="4">
                        <template slot="title">房产经纪
                            <img class="arrow" src="../assets/images/arrow_down.png" alt="">
                        </template>
                        <el-menu-item index="/new">新房</el-menu-item>
                        <el-menu-item index="/second">二手房</el-menu-item>
                        <el-menu-item index="/rent">租房</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/deal">交易服务</el-menu-item>
                    <!--<el-submenu index="5">-->
                    <!--<template slot="title">交易服务-->
                    <!--<img class="arrow" src="../assets/images/arrow_down.png" alt="">-->
                    <!--</template>-->
                    <!--<el-menu-item :index="'/deal/' + item.id.toString()" v-for="item in list"-->
                    <!--:key="item.id">-->
                    <!--<div class="">{{ item.title }}</div>-->
                    <!--</el-menu-item>-->
                    <!--</el-submenu>-->
                    <el-menu-item index="/expert">专家团队</el-menu-item>
                    <el-menu-item index="/lawyer">律师调解</el-menu-item>
                    <el-menu-item index="/lease">存房租赁</el-menu-item>
                    <el-menu-item index="/login" v-show="docData.hasLogin === '0'">
                        <template slot="title">
                            <!--<i class="el-icon-location"></i>-->
                            <img src="../assets/images/nav/user.png" alt="">
                            <span style="padding-left: 10px;">登录/注册</span>
                        </template>

                    </el-menu-item>
                    <el-submenu index="10" v-if="docData.hasLogin === '1'">
                        <template slot="title">
                            <i class="iconfont" v-show="userInfo.headimgurl === ''">&#xe774;</i>
                            <img class="" v-show="userInfo.headimgurl !== ''" :src="userInfo.headimgurl" alt=""
                                 style="width: 30px;height: 30px;border-radius: 50%">
                            {{ userInfo.name }}
                            <img class="arrow" src="../assets/images/arrow_down.png" alt="">
                        </template>
                        <el-menu-item :index="'/personal/' + item.id" v-for="item in tabs"
                                      :key="item.id">
                            <div class="">{{ item.value }}</div>
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
                <div class="loginRes" @click="LoginOUT" v-show="docData.hasLogin === '1'">
                    <div class="loginRes_title">退出</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import { category, about} from "../apiNew/index";

	export default {

		name: '',
		data() {
			return {
				activeIndex: '0',
				list: [],
				page: 1,
				limit: 100,
				total: 0,
				auction: [],// 拍卖
				takeRent: [],// 拍租

				// username: '',
				userInfo: {},
				personalIndex: '',
				tabs: [{id: '0', value: '个人资料'}, {id: '1', value: '我的收藏'},
					{id: '2', value: '我要卖房'}, {id: '3', value: '我要出租'},
					{id: '4', value: '我要买房'}, {id: '5', value: '我要租房'},
					{id: '6', value: '我的竞拍'}, {id: '7', value: '我的提醒'},
					{id: '8', value: '账户注销'}],
				navActive: false,
				logo: '',
				docData: {
					hasLogin: '0',// 无效登录
				}
			}
		},
		created() {
			// 		localStorage.setItem('isLogin','0')
			var that = this
			about({}).then(res => {
				// console.log(res)
				this.logo = res.data.url_logo_pc
				localStorage.setItem('logo', res.data.url_logo_pc)
			}).catch(error => {
				this.$dialog.toast({
					mes: error.msg,
					timeout: 2000,
					icon: "error"
				});
			})
			// console.log(localStorage.getItem('isLogin'))
			if (localStorage.getItem('isLogin') === null) {
				this.docData.hasLogin = '0'
				localStorage.setItem('isLogin', '0')
			} else {
				this.docData.hasLogin = localStorage.getItem('isLogin')
			}
			// this.docData.hasLogin = localStorage.getItem('isLogin')
			if (localStorage.getItem('isLogin') === '1') {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
			// console.log(this.userInfo)
			// console.log(this.docData.hasLogin)
			// window.addEventListener('setItem', () => {
			// 	// console.log(localStorage.getItem('isLogin')
			// 	// this.docData.hasLogin = localStorage.getItem('isLogin')
			// 	// this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			// 	// console.log(this.userInfo)
			// 	// this.init()
			// 	// this.setCurrentRoute()
			// })
			window.addEventListener('setItemEvent', function (e) {
				// console.log(e)
				if (e.key === 'isLogin') {
					// console.log(e.newValue)
					that.docData.hasLogin = e.newValue
					// console.log(that.docData.hasLogin)
					if (e.newValue === '0') {
						localStorage.removeItem('token');
						localStorage.removeItem('userInfo');
					}
				}
				if (e.key === 'userInfo') {
					that.userInfo = JSON.parse(e.newValue)
				}
				if (e.key === 'token') {
					localStorage.setItem('token', e.newValue)
				}
			})
			// window.addEventListener("removeItemEvent", function (e) {
			// if (localStorage.getItem("token")) {
			// 	if (e.key === 'token') {
			// 		alert("key值为demo，删除成功");
			// 	}
			// } else {
			// 	alert("本地数据无key值为demo")
			// }
			// })
		},
		mounted() {
			this.init()
			// this.getService()
			this.getCategory()
			this.index_logo = localStorage.getItem('index_logo')
		},
		methods: {
			init() {
				// meInfo({
				// 	token: localStorage.getItem('token')
				// }).then(ress => {
				// 	// console.log(ress)
				// 	if (ress.code === 0) {
				// 		// this.$addLocalStorageEvent('isLogin', result.data.ret)
				// 		localStorage.setItem('isLogin', result.data.ret);
				// 		// this.$addLocalStorageEvent('userInfo', JSON.stringify(ress.data));
				// 		localStorage.setItem('userInfo', JSON.stringify(ress.data));
				// 	}
				// }).catch(err => {
				// 	localStorage.setItem('isLogin', 0);
				// 	// console.log(err)
				// })
			},

			handleSelect(key, keyPath) {
				// console.log(key, keyPath)
				if (keyPath[1] != undefined) {
					var id = keyPath[1].split('/')[2]
					var categoryId = keyPath[1].split('/')[3]
					console.log(keyPath[0],id,categoryId)
					if (keyPath[0] === '2') {
						this.$addStorageEvent("categoryType", 0);
						this.$addStorageEvent("categoryId", categoryId);
					}
					if (keyPath[0] === '3') {
						this.$addStorageEvent("categoryType", 1);
						this.$addStorageEvent("categoryId", categoryId);
					}
					if (keyPath[0] === '5') {
						this.$addStorageEvent("dealId", id);
					}
					if (keyPath[0] === '10') {
						this.$addStorageEvent("personalIndex", id);
					}
				}
			},
			// 资产分类
			getCategory() {
				// 拍卖
				category({
					is_type: 0
				}).then(res => {
					// console.log(res.data[0])
					this.auction = res.data
				}).catch(error => {
					console.log(error)
				})
				// 拍租
				category({
					is_type: 1
				}).then(res => {
					// console.log(res)
					this.takeRent = res.data
				}).catch(error => {
					console.log(error)
				})
			},
			// 交易服务
			// getService() {
			// 	services({
			// 		page: this.page,
			// 		limit: this.limit,
			// 	}).then(res => {
			// 		console.log(res)
			// 		this.list = res.data.data
			// 		this.total = res.data.total
			//
			// 	}).catch(error => {
			// 		console.log(error)
			// 	})
			// },
// 登录
			toLogin() {
				this.$addStorageEvent("loginSource", 1);
				this.$router.push({name: 'login'})
			},
			//退出登录
			LoginOUT() {
				localStorage.setItem('isLogin', '0');
				localStorage.removeItem('token');
				localStorage.removeItem('userInfo');
				this.$router.push({path: '/home'})
			},

			setCurrentRoute() {
				// console.log(this.$route.path)
				var path = this.$route.path.split('/')[1]
				// console.log(path)
				if (path === 'newDetail') {
					this.activeIndex = '/new'
				} else if (path === 'rentDetail') {
					this.activeIndex = '/rent'
					// console.log(this.activeIndex)
				} else if (path === 'secondDetail') {
					this.activeIndex = '/second'
					// console.log(this.activeIndex)
				} else if (path === 'auctionDetail') {
					var type = this.$route.path.split('/')[2]
					// console.log(this.$route.path)
					this.activeIndex = '/auction/' + Number(type) + '/' + localStorage.getItem('categoryId')
				} else {
					this.activeIndex = this.$route.path;//关键   通过他就可以监听到当前路由状态并激活当前菜单
					// console.log(this.activeIndex)
				}
				// console.log(this.activeIndex)
				if (path === 'new' || path === 'newDetail' || path === 'second' ||
					path === 'secondDetail' || path === 'rent' || path === 'rentDetail'
					|| path === 'auctionDetail' || path === 'expert' || path === 'aboutUs' ||
					path === 'personal' || path === 'subDetail') {
					return this.navActive = true
				} else {
					this.navActive = false
				}
			}
		},
		watch: {
			$route() {
				this.setCurrentRoute()
			},
			// docData: {
			// 	handler(newVal) {
			// 		console.log(newVal)
			// 		console.log(localStorage.getItem('isLogin'))
			// 		// this.change_number++
			// 	},
			// 	deep: true
			// }
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .nav_box {
        display: flex;
        height: 98px;
        justify-content: center;
        /*overflow-y: hidden;*/
        overflow-x: scroll;
        /*background: #000;*/
        .nav {
            /*width: 1200px;*/
            /*height: 115px;*/
            display: flex;
            align-items: center;
            justify-content: space-between;

            .nav_left {
                width: 130px;
                height: 48px;
                display: flex;
                align-items: center;
                flex-shrink: 0;

                .nav_logo {
                    width: 100%;
                }
            }
            .nav_right {
                flex: 1;
                /*min-width: 1060px;*/
                display: flex;
                align-items: center;
                justify-content: space-between;

                /deep/ .el-menu {
                    /*width: 1020px;*/
                    display: flex;
                    flex-wrap: nowrap;
                    border-bottom: none;
                    background-color: transparent !important;
                    /*overflow-x: scroll;*/
                    .el-menu-item {
                        height: 80px;
                        line-height: 80px;
                        background-color: transparent !important;
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #fff !important;
                        border-bottom: none;
                    }

                    .el-menu-item.is-active {
                        color: #FFB01E !important;
                    }
                    .el-menu-item:hover {
                        background-color: transparent !important;
                    }

                    .el-submenu {
                        .el-submenu__title {
                            height: 80px;
                            font-size: 16px;
                            line-height: 80px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #fff !important;
                            background-color: transparent !important;
                            border-bottom: none;
                            .arrow {
                                width: 13px;
                                height: 9px;
                                margin-left: 4px;
                            }

                            .el-icon-arrow-down {
                                display: none;
                            }
                        }
                    }
                    .el-submenu.is-active {
                        .el-submenu__title {
                            color: #FFB01E !important;
                        }
                    }
                }
                .loginRes {
                    /*width: 80px;*/
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                    cursor: pointer;

                    /*.loginRes_img {*/
                    /*width: 30px;*/
                    /*height: 30px;*/
                    /*display: block;*/
                    /*border-radius: 50%;*/
                    /*}*/
                    .loginRes_title {
                        width: 50px;
                        /*margin-left: 10px;*/
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #fff;
                        text-align: center;
                        line-height: 22px;
                        letter-spacing: 4px;
                    }
                }
            }
        }
    }

    .navActive {
        background: #000;
    }

</style>